import { DepInjMixin, requires } from '@APP/mixins/dependency';
import { QuestionsService } from '@APP/services/questions-service';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators';
import { commonPopupMobileStyle, commonPopupStyle } from '../../styles/common-style';
import { t } from '../../utils/locale';
import { DeviceAwareComponent } from '../components/device-aware-component';
import { PopupService } from '@APP/services/popup-service';
import { eventBus } from '@APP/utils/event-bus';
import { Events } from '@APP/events/app-events';
import { ConfigService } from '@APP/services/config-service';
import { ManWatchingHorizon } from '../icons/icons';
import { getStateFullName } from '@ahoy/model';

type OwnDeps = {
  questionsService: QuestionsService;
  popupService: PopupService;
  configService: ConfigService;
};
@requires(QuestionsService.serviceName, PopupService.serviceName, ConfigService.serviceName)
@customElement('non-eligible-popup-type-2')
export class NonEligablePopupTypeTwo extends DepInjMixin<OwnDeps>(DeviceAwareComponent) {
  static get styles() {
    return [
      commonPopupStyle,
      css`
        .title {
          font-size: 8rem;
        font-weight: 700;
        margin-bottom: 0;
       }
      .sub-title{
        font-size: 4rem;
        font-weight: 700;
        margin-bottom: 0;
        max-width:61.375rem;
        color: var(--c-text);
      }
      .message{
        margin:0;
        max-width:53.25rem;
       }
     
   
    `,
    ];
  };

  static get mobileStyles() {
    return [commonPopupMobileStyle];
  }

  @property({ type: String })
    value: string = '';

  private subs: Function[] = [];

  connectedCallback(): void {
    super.connectedCallback();
    this.subs.push(eventBus().on(Events.Type.FeedbackSection, () => {
      this.deps.questionsService.requestSectionChange('S_Feedback');
      this.deps.popupService.closePopup();
    }));
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.subs.forEach(f => f());
  }

  renderMobileLayout() {
    const watercraftName = this.deps.questionsService.model.getBoatDisplayName();
    const stateName = getStateFullName(this.deps.questionsService.getCheckByState());

    return html`
      <div class="grid-container">
       <div class="col-1">
         <h2 class="sub-title">${t('T_Package_Selection_2_Type2', watercraftName)}</h2><br>
       </div>
       <div class="col-2">
        ${ManWatchingHorizon}
      </div>
      <div class="col-3">
        <h3 class="message">${t('T_Package_Selection_3_Type2', stateName)}</h3>
        <h3 class="message">${t('T_Package_Selection_4_Type2', stateName)} ${t('T_Package_Selection_5_Type2', watercraftName)} ${t('T_Package_Selection_6_Type2')}</h3>
        <br>
        <h3 class="message">${t('T_Package_Selection_7_Type2')}</h3>
        <h3 class="message">${t('T_Package_Selection_8_Type2')} ${t('T_Package_Selection_9_Type2')}</h3>
      </div>
     </div>
    `;
  }

  renderDesktopLayout() {
    const watercraftName = this.deps.questionsService.model.getBoatDisplayName();
    const stateName = getStateFullName(this.deps.questionsService.getCheckByState());

    return html`
     <div class="grid-container">
       <div class="col-1">
        <h2 class="sub-title">${t('T_Package_Selection_2_Type2', watercraftName)}</h2>
        <br>
        <h3 class="message">${t('T_Package_Selection_3_Type2', stateName)}</h3>
        <h3 class="message">${t('T_Package_Selection_4_Type2', stateName)} ${t('T_Package_Selection_5_Type2', watercraftName)} ${t('T_Package_Selection_6_Type2')}</h3>
        <br>
        <h3 class="message">${t('T_Package_Selection_7_Type2')}</h3>
        <h3 class="message">${t('T_Package_Selection_8_Type2')} ${t('T_Package_Selection_9_Type2')}</h3>
      </div>
      <div class="col-2"></div>
     </div>
    `;
  }

  renderContent() {
    return this.userDevice === 'desktop' ? this.renderDesktopLayout() : this.renderMobileLayout();
  }
}
